import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { useTranslation } from "react-i18next";

import { RepLIProviderTextField } from '../../../components';
import Cookies from 'universal-cookie';


const cookies = new Cookies();

const UserInformationForm = props => {
    const { t } = useTranslation();

    const [availableEmail, setAvailableEmail] = useState(true);
    const [emailRequired, setEmailRequired] = useState(false);
    const [emailValidation, setEmailValidation] = useState(false);
    const [emailUnavailbilityMessage, setEmailUnavailbilityMessage] = useState('');

    const skeletonHeight = 80;

    useEffect(() => {
        props.validator.showMessageFor('email');
    });

    useEffect(() => {
        setEmailUnavailbilityMessage(
            availableEmail ? emailRequired ? 'Email is required' :
                emailValidation ? 'Email is invalid' :
                    '' : t('module.provider.addPatient.message.duplicatedEmail')
        );
    }, [availableEmail, emailRequired, emailValidation, t]);

    useEffect(() => {
        if (props.submitted) {
            checkDuplicatedEmail();
            props.validator.showMessages();
        }
    }, [props.submitted, props.validator]);

    const checkDuplicatedEmail = async () => {
        try {
            if (props.email === "") {
                setAvailableEmail(true);
                setEmailRequired(true);
                setEmailValidation(false);
                props.validator.showMessageFor('email');
            }
            else {
                const validEmail = new RegExp(
                    '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,}$'
                );

                if (!validEmail.test(props.email)) {
                    setAvailableEmail(true);
                    setEmailRequired(false);
                    setEmailValidation(true);
                    props.validator.showMessageFor('email');
                    return;
                }
                else {
                    const response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT_GETBYEMAIL}?${new URLSearchParams({
                        email: props.email,
                        id: props.id
                    })}`, {
                        headers: {
                            'X-ACCESS-TOKEN': cookies.get('token')
                        }
                    });
                    setAvailableEmail(response.ok);
                    setEmailRequired(false);
                    setEmailValidation(false);
                    props.validator.showMessageFor('email');
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                {
                    props.loading ?
                        <Skeleton height={skeletonHeight} /> :
                        <RepLIProviderTextField
                            // InputProps={{ readOnly: props.editMode === 'insert' ? false : true }}
                            label={`${t('common.form.label.email')}*`}
                            error={!availableEmail || emailRequired || emailValidation}
                            helperText={emailUnavailbilityMessage}
                            onChange={props.onEmailChange}
                            onBlur={checkDuplicatedEmail}
                            value={props.email}
                        />
                }
            </Grid>
            <Grid item xs={6}>
                {
                    props.loading ?
                        <Skeleton height={skeletonHeight} /> :
                        <RepLIProviderTextField
                            label={`${t('signUp.inputPlaceholders.firstName')}*`}
                            error={props.submitted && !props.validator.fieldValid('firstName')}
                            helperText={props.validator.message('firstName', props.firstName, 'required')}
                            onChange={props.onFirstNameChange}
                            value={props.firstName}
                        />
                }
            </Grid>
            <Grid item xs={6}>
                {
                    props.loading ?
                        <Skeleton height={skeletonHeight} /> :
                        <RepLIProviderTextField
                            label={`${t('signUp.inputPlaceholders.lastName')}*`}
                            error={props.submitted && !props.validator.fieldValid('lastName')}
                            helperText={props.validator.message('lastName', props.lastName, 'required|alpha')}
                            onChange={props.onLastNameChange}
                            value={props.lastName}
                        />
                }
            </Grid>
        </Grid>
    )
};

export default UserInformationForm;
